import React, { FC } from 'react';
import clsx from 'classnames';

import styles from './divider.module.scss';

export const Divider: FC<{ className?: string; vertical?: boolean }> = props => {
  const { className, vertical = false } = props;

  return <div className={clsx(styles.container, { [styles.vertical]: vertical }, className)} />;
};
